import * as React from "react";
import ReactTable from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ContenidoPestañaEmpresa from "./ContenidoPestañaEmpresa";
import { OrdenamientoProps, ColumnaProps } from "../../../general/modelo/TablaColumnas";
import { EstructuraEmpleado, EstructuraEmpresa, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";

export default class TablaEmpleadosEmpresa extends React.Component<TablaEmpleadosEmpresaProps, TablaEmpleadosEmpresaState> {

    columns = [{
        id: 'codigoSede',
        Header: "Sede",
        accessor: "codigoSede",
        width: 45
    }, {
        id: 'codigoCT',
        Header: "Centro de Trabajo",
        accessor: "codigoCT",
        width: 125,
    }, {
        id: 'fechaInicio',
        Header: "Inicio Cobertura",
        accessor: "informacionEmpleado.fechaInicio",
        width: 110,
    }, {
        id: 'fechafin',
        Header: "Fin Cobertura",
        accessor: "informacionEmpleado.fechafin",
        width: 105,
    }, {
        id: 'identificacionEmpleado',
        Header: "Identificación", 
        accessor: "identificacionEmpleado",
        width: 115,
    }, {
        id: 'nombreEmpleado',
        Header: "Nombre Empleado",
        Cell: props => (this.renderNombreEmpleado(props)),
        sortable: false
    }, {
        id: 'ibc',
        Header: "IBC",
        Cell: props => (this.renderIBC(props)),
        width: 85,
    }, { 
        Header: "Nacimiento",
        accessor: "informacionEmpleado.fechaNacimiento",
        width: 100,
        sortable: false
    }, { 
        Header: "Sexo",
        accessor: "informacionEmpleado.sexoTrabajador",
        width: 45,
        sortable: false
    }, { 
        Header: "EPS",
        accessor: "informacionEmpleado.epsTrabajador",
        width: 65,
        sortable: false
    }, { 
        Header: "AFP",
        accessor: "informacionEmpleado.afpTrabajador",
        width: 65,
        sortable: false
    }];

    constructor(props: any) {
        super(props);

        this.state = {
            listaTrabajadores: [],
            totalTrabajadores: 0,
            listaPaginada: [],
            paginaActual: 0,
            registrosPorPagina: 20 
        };
    }

    renderNombreEmpleado = (props: any) => {
        const nombreCompleto = `${props.original.informacionEmpleado.primerApellidoTrabajador} ${props.original.informacionEmpleado.segundoApellidoTrabajador}
                                ${props.original.informacionEmpleado.primerNombreTrabajador} ${props.original.informacionEmpleado.segundoNombreTrabajador}`;
        if(nombreCompleto.length > 57) {
            const tooltip = (
                <Tooltip id="tooltip" className="tooltip-pos">{nombreCompleto}</Tooltip>
            );
            return(
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <span>{nombreCompleto}</span>
                </OverlayTrigger>
            );
        }
        return(nombreCompleto);
    };

    renderIBC = (props: any) => {
        return(`$${props.original.informacionEmpleado.ibc}`);
    };

    componentDidMount() {
        if(this.state.listaTrabajadores.length === 0 || this.state.listaPaginada.length === 0) {
            this.obtenerListaEmpleados();
        }
    }

    render() {
        return(
            <div>
                <ContenidoPestañaEmpresa
                    estructuraEmpresa={this.props.estructuraEmpresa}
                    estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    tituloCabecera={"Datos Empleados Sistema de Afiliación Transaccional"}
                    contenido={this.renderContenido()}
                />
            </div>
        );
    }

    renderContenido() {
        const {registrosPorPagina, paginaActual, listaPaginada} = this.state;

        if(listaPaginada.length > 0 && paginaActual >= 0) {
            return this.renderTablaEmpleados(listaPaginada, this.calcularTotalPaginasEmpleados(registrosPorPagina), registrosPorPagina, paginaActual);
        } else {
            return false;
        }
    }

    renderTablaEmpleados(listaPaginada: Array<DatosEmpleado>, paginas: number, tamanoPagina: number, paginaActual: number) {
        
        let numRegistros = 0;

        if (listaPaginada.length < tamanoPagina) {
            numRegistros = listaPaginada.length;
        } else {
            numRegistros = tamanoPagina;
        }

        return(
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{listaPaginada.length}</span> Lista de Empleados Ingresados
                    </h2>
                </div>
                <ReactTable data={listaPaginada}
                            columns={this.columns}
                            manual
                            defaultPageSize={numRegistros}
                            pageSizeOptions={this.calcularOpciones(numRegistros)}
                            page={paginaActual}
                            pageSize={numRegistros}
                            sortable
                            resizable
                            previousText={"Anterior"}
                            nextText={"Siguiente"}
                            loadingText={"Cargando..."}
                            noDataText={"No se ha encontrado información."}
                            pageText={"Página"}
                            ofText={"de"}
                            rowsText={""}
                            className={"-highlight -striped font-table"}
                            pages={paginas}
                            onPageChange={(pageIndex) => {
                                this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                                this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                            }}
                            onSortedChange={(newSorted, column, shiftKey) => {
                                this.ordernamientoLista(newSorted, column, shiftKey);
                            }}    
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        this.actualizarEmpleadosPaginacion(pageIndex, (pageSize ? pageSize : tamanoPagina));
    }

    obtenerListaEmpleados() {
        const totalSedes = this.props.estructuraEmpresa.sedes.length;
        const listaEmpleados: Array<DatosEmpleado> = [];
        if(totalSedes > 0) {
            this.props.estructuraEmpresa.sedes.forEach(sede => {
                if(sede.centrosTrabajo.length > 0) {
                    sede.centrosTrabajo.forEach(ct => {
                        ct.empleados.forEach(empleado => listaEmpleados.push({
                            informacionEmpleado: empleado,
                            identificacionEmpleado: this.construirIdentificacionEmpleado(empleado),
                            codigoCT: ct.codigoCentroTrabajo,
                            nombreCT: ct.nombreCentroTrabajo,
                            codigoSede: sede.codigoSede,
                            nombreSede: sede.nombreSede
                        }));
                    });
                }
            });
        }

        let numRegistros;
        
        if (listaEmpleados.length < this.state.registrosPorPagina) {
            numRegistros = listaEmpleados.length;
        } else {
            numRegistros = this.state.registrosPorPagina;
        }

        const listaPaginadaEmpleados = this.calcularEmpleadosPorPagina(listaEmpleados, numRegistros, 1);

        this.setState({
            listaTrabajadores: listaEmpleados,
            totalTrabajadores: listaEmpleados.length, 
            listaPaginada: listaPaginadaEmpleados,
            paginaActual: 0,
            registrosPorPagina: numRegistros
        });
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10,20,30,50,100,200];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if( elemento ) {
            return arreglo;
        } else {
            return [...arreglo,tamanoPagina].sort( (a, b) => {return a-b;} );
        }
    }

    calcularTotalPaginasEmpleados(registrosPorPagina: number) {
        const dividirRegistros = this.state.totalTrabajadores / registrosPorPagina;
        return Math.ceil(dividirRegistros);
    }

    calcularEmpleadosPorPagina(listaTrabajadores: Array<DatosEmpleado>, registrosPorPagina: number, paginaNum: number) {
        return listaTrabajadores.slice((paginaNum - 1) * registrosPorPagina, paginaNum * registrosPorPagina);
    }

    actualizarEmpleadosPaginacion(pageIndex: number, registrosPorPagina: number) {
        const listaPaginadaEmpleados = this.calcularEmpleadosPorPagina(this.state.listaTrabajadores, registrosPorPagina, pageIndex + 1);
        this.setState({
            listaPaginada: listaPaginadaEmpleados,
            registrosPorPagina: registrosPorPagina, 
            paginaActual: pageIndex
        });
    }

    ordernamientoLista(ordenamientoProps: Array<OrdenamientoProps>, columnaProps: ColumnaProps, shiftKey: boolean) {
        ordenamientoProps.forEach((ordenamiento) => {
            const ordenamientoTipo = ordenamiento.desc ? 1 : -1; 
            const listaOrdenada = this.state.listaTrabajadores.sort((a, b) => {
                if(ordenamiento.id === 'codigoSede') {
                    if (a.codigoSede > b.codigoSede) return 1 * ordenamientoTipo;
                    if (a.codigoSede < b.codigoSede) return -1 * ordenamientoTipo;
                    return 0;
                }
                if(ordenamiento.id === 'codigoCT') {
                    if (a.codigoCT > b.codigoCT) return 1 * ordenamientoTipo;
                    if (a.codigoCT < b.codigoCT) return -1 * ordenamientoTipo;
                    return 0;
                }
                if(ordenamiento.id === 'fechaInicio') {
                    if (a.informacionEmpleado.fechaInicio > b.informacionEmpleado.fechaInicio) return 1 * ordenamientoTipo;
                    if (a.informacionEmpleado.fechaInicio < b.informacionEmpleado.fechaInicio) return -1 * ordenamientoTipo;
                    return 0;
                }
                if(ordenamiento.id === 'fechafin') {
                    if (a.informacionEmpleado.fechafin > b.informacionEmpleado.fechafin) return 1 * ordenamientoTipo;
                    if (a.informacionEmpleado.fechafin < b.informacionEmpleado.fechafin) return -1 * ordenamientoTipo;
                    return 0;
                }
                if(ordenamiento.id === 'identificacionEmpleado') {
                    if (a.identificacionEmpleado > b.identificacionEmpleado) return 1 * ordenamientoTipo;
                    if (a.identificacionEmpleado < b.identificacionEmpleado) return -1 * ordenamientoTipo;
                    return 0;
                }
                if(ordenamiento.id === 'ibc') {
                    if (a.informacionEmpleado.ibc > b.informacionEmpleado.ibc) return 1 * ordenamientoTipo;
                    if (a.informacionEmpleado.ibc < b.informacionEmpleado.ibc) return -1 * ordenamientoTipo;
                    return 0;
                }
                return 0;
            });
            const listaPaginadaEmpleados = this.calcularEmpleadosPorPagina(listaOrdenada, this.state.registrosPorPagina, this.state.paginaActual + 1);
            this.setState({
                listaTrabajadores: listaOrdenada,
                listaPaginada: listaPaginadaEmpleados
            });         
        });
    }

    construirIdentificacionEmpleado(informacionEmpleado: EstructuraEmpleado) {
        return(
            `${informacionEmpleado.tipoDocumentoIdentificacion}${informacionEmpleado.numeroDocumentoIdentificacion}`
        );
    }
}

interface TablaEmpleadosEmpresaProps {
    estructuraEmpresa: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa
}

interface TablaEmpleadosEmpresaState {
    listaTrabajadores: Array<DatosEmpleado>,
    totalTrabajadores: number,
    listaPaginada: Array<DatosEmpleado>,
    paginaActual: number,
    registrosPorPagina: number 
}

interface DatosEmpleado {
    informacionEmpleado: EstructuraEmpleado,
    identificacionEmpleado: string,
    codigoCT: string,
    nombreCT: string
    codigoSede: string,
    nombreSede: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/TablaEmpleadosEmpresa.tsx